import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ReportInfo } from '../../../Models/Models/Reports/ReportInfo';
import { IJsonDate } from '../../../System/IJsonDate';
import { PerformanceMethod } from '../../../Constants/Enums/Domain/PerformanceMethod';

declare var IS_RUNNING_IN_APP_POOL;

export class PerformanceSummaryReportClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(hierarchyIds: Array<string>, fromDateTime: IJsonDate, toDateTime: IJsonDate, fromInception: boolean, performanceMethod: PerformanceMethod, customerId: number, consolidateHeadAccountHierarchyId: string): Promise<ReportInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/Performance/PerformanceSummaryReport/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, fromDateTime: fromDateTime, toDateTime: toDateTime, fromInception: fromInception, performanceMethod: performanceMethod, customerId: customerId, consolidateHeadAccountHierarchyId: consolidateHeadAccountHierarchyId }

    return AjaxWrapper.post<ReportInfo, any>(url, data);
  }
}

